export default "__VITE_ASSET__J$UVjsIJ__"